import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';

@Injectable({
  providedIn: 'root'
})
export class ProcesamientoDeComisionesExcolaboradoresService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.procesarComisionesExcolaboradores;
  }

  getTodo() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo);
  }

  getporId(idLiquidacion) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorId + idLiquidacion);
  }

  getLiquidacion(innObj: any) {
    console.log("getLiquidacion", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.procesarLiquidacion, innObj);
  }

  procesarLiquidacion(innObj: any) {
    console.log("getLiquidacion", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.procesarLiquidacion, innObj);
  }

  guardarLiquidacion(innObj: any) {
    console.log("getLiquidacion", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.guardarLiquidacion, innObj);
  }

  getTiposDeVendedores() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo);
  }

  getTipoDeVendedoreByID(id: any) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorId + id);
  }

  getTiposDeVendedoresPorEstado(estado: string) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorEstado + estado);
  }


  saveTipoDeVendedore(innObj: any) {
    console.log("getLiquidacion", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.procesarLiquidacion, innObj);
  }

  updateTipoDeVendedore(innObj: any) {
    console.log("updateTipoDeVendedore", innObj)
    return this.commom.peticionPutConHeader(this.urlComisiones + this.diccionarioUrl.actualizar, innObj);
  }

  deleteTipoDeVendedore(innIdDireccion: string) {
    return this.commom.peticionDeleteConHeader(this.urlComisiones + this.diccionarioUrl.eliminar + `${innIdDireccion}`);
  }

  cerrarLiquidacion(id: any) {
    return this.commom.peticionPutConHeader(this.urlComisiones + this.diccionarioUrl.cerrarLiquidacion + id, {});
  }

  unidadesDeNegocio() {
    return this.commom.peticionGetConHeader(this.urlMaestros + this.diccionarioUrl.unidadesDeNegocio);
  }

  deleteComision(id: string) {
    return this.commom.peticionPutConHeader(this.urlComisiones + this.diccionarioUrl.eliminarLiquidacion + `${id}`, {});
  }

  obtenerTiposDeVendedoresPorUnidadesDeNegocios(unidadesDeNegocios: any) {
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTiposDeVendedoresPorUnidadesDeNegocios, unidadesDeNegocios);
  }

  filtroEstado(id: any) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.filtroEstado + id);
  }

  filtroDetalle(filtro: any, liquidacion: any) {
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.filtroDetalle + filtro, liquidacion);
  }

  // cerrarLiquidacion(id: string) {
  //   return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.cerrarLiquidacion + id);
  // }

}
